import type { ConditionData } from '@stratumn/studio-shared';

export const initialConditionData: ConditionData = {
  selectedVariable: null,
  condition: null
};
